export interface SetupNavItem {
  to: string
  label: string
  blurb: string
}

/**
 * Single source of truth for every guide under "Setup Instructions".
 * The sidebar group (Layout) and the setup page breadcrumbs both read this,
 * so adding a guide here updates navigation everywhere.
 */
export const SETUP_NAV_ITEMS: SetupNavItem[] = [
  { to: '/setup/mcp', label: 'MCP Setup', blurb: 'Connect a client over remote MCP' },
  {
    to: '/setup/project',
    label: 'Project Setup',
    blurb: 'Install skill + AGENTS.md and index code per project',
  },
]

export function setupTitleForPath(pathname: string): string | undefined {
  return SETUP_NAV_ITEMS.find((item) => pathname.startsWith(item.to))?.label
}
